type IdleWindow = Window & {
    requestIdleCallback?: (callback: () => void, options?: { timeout: number }) => number
}

/** Runs heavy one-off work when the browser is idle, falling back to a short timeout. */
export const whenIdle = (callback: () => void, timeout = 2000): void => {
    const target = window as IdleWindow

    if (typeof target.requestIdleCallback === 'function') {
        target.requestIdleCallback(callback, { timeout })

        return
    }

    window.setTimeout(callback, 16)
}
